import script from "./CarouselNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselNavigation.vue?vue&type=script&setup=true&lang=js"

import "./CarouselNavigation.vue?vue&type=style&index=0&id=2b04eb5f&lang=scss"

const __exports__ = script;

export default __exports__